module.exports = __webpack_public_path__ + "static/media/vanessa-bg.d9d2c99a.mp4";